export const ICON_ADD_BLANK = 'icon-add-blank';
export const ICON_ADD_ROW_ABOVE = 'icon-add-row-above';
export const ICON_ADD_ROW_BELOW = 'icon-add-row-below';
export const ICON_ADD_ROW_LEFT = 'icon-add-row-left';
export const ICON_ADD_ROW_RIGHT = 'icon-add-row-right';
export const ICON_AI = 'icon-ai';
export const ICON_ANALYTICS = 'icon-analytics';
export const ICON_ARCHIVE = 'icon-archive';
export const ICON_ARROW_DOWN = 'icon-arrow-down';
export const ICON_ARROW_DOWN_LINE = 'icon-arrow-down-line';
export const ICON_ARROW_DOWN_LINE_SM = 'icon-arrow-down-line-sm';
export const ICON_ARROW_LEFT = 'icon-arrow-left';
export const ICON_ARROW_LEFT_LINE = 'icon-arrow-left-line';
export const ICON_ARROW_LEFT_LINE_SM = 'icon-arrow-left-line-sm';
export const ICON_ARROW_RIGHT = 'icon-arrow-right';
export const ICON_ARROW_RIGHT_LINE = 'icon-arrow-right-line';
export const ICON_ARROW_RIGHT_LINE_SM = 'icon-arrow-right-line-sm';
export const ICON_ARROW_UP = 'icon-arrow-up';
export const ICON_ARROW_UP_LINE = 'icon-arrow-up-line';
export const ICON_ARROW_UP_LINE_SM = 'icon-arrow-up-line-sm';
export const ICON_ATTACHMENT = 'icon-attachment';
export const ICON_AUDIT = 'icon-audit';
export const ICON_BOLD = 'icon-bold';
export const ICON_CALENDAR = 'icon-calendar';
export const ICON_CCDA = 'icon-ccda';
export const ICON_CHANGE_PATIENT = 'icon-change-patient';
export const ICON_CHANGE_PATIENT_V2 = 'icon-change-patient-v2';
export const ICON_CHECK = 'icon-check';
export const ICON_CHECK_FILES = 'icon-check-files';
export const ICON_CHECKED_REPORT = 'icon-checked-report';
export const ICON_CLINICAL_SHEET = 'icon-clinical-sheet';
export const ICON_CLOCK = 'icon-clock';
export const ICON_COLLABORATION = 'icon-collaboration';
export const ICON_COPY = 'icon-copy';
export const ICON_COPY_LINK = 'icon-copy-link';
export const ICON_CREDIT_CARD = 'icon-credit-card';
export const ICON_CSV = 'icon-csv';
export const ICON_DASHBOARD = 'icon-dashboard';
export const ICON_DELETE = 'icon-delete';
export const ICON_DELETE_COLUMN = 'icon-delete-column';
export const ICON_DELETE_ROW = 'icon-delete-row';
export const ICON_DICOM = 'icon-dicom';
export const ICON_DICOM_NO_TEXT = 'icon-dicom-no-text';
export const ICON_DIRECTORIES = 'icon-directories';
export const ICON_DIVISIONS = 'icon-divisions';
export const ICON_DOTDOTDOT = 'icon-dotdotdot';
export const ICON_DOWNLOAD = 'icon-download';
export const ICON_DOWNLOAD_CD = 'icon-download-cd';
export const ICON_DRAGGABLE = 'icon-draggable';
export const ICON_DRAGGABLE_CORNER = 'icon-draggable-corner';
export const ICON_DRAGGABLE_VERTICAL = 'icon-draggable-vertical';
export const ICON_DROP_DOWN_SM = 'icon-drop-down-sm';
export const ICON_DROP_UP_SM = 'icon-drop-up-sm';
export const ICON_DROPDOWN = 'icon-dropdown';
export const ICON_EDIT = 'icon-edit';
export const ICON_EDIT_BOX = 'icon-edit-box';
export const ICON_EDIT_LINE = 'icon-edit-line';
export const ICON_ERASE = 'icon-erase';
export const ICON_ERROR_HEX = 'icon-error-hex';
export const ICON_EXPAND = 'icon-expand';
export const ICON_EXPAND_V2 = 'icon-expand-v2';
export const ICON_EXTERNAL_LINK = 'icon-external-link';
export const ICON_EXTERNAL_LINK_LINE = 'icon-external-link-line';
export const ICON_EXTERNAL_REPORT = 'icon-external-report';
export const ICON_EXTERNAL_USER = 'icon-external-user';
export const ICON_FAILURE = 'icon-failure';
export const ICON_FAX = 'icon-fax';
export const ICON_FEEDBACK = 'icon-feedback';
export const ICON_FILES = 'icon-files';
export const ICON_FILTER = 'icon-filter';
export const ICON_FOLDER_BREAKING = 'icon-folder-breaking';
export const ICON_FONTSIZEDOWN = 'icon-fontsizedown';
export const ICON_FONTSIZEUP = 'icon-fontsizeup';
export const ICON_HAPPY = 'icon-happy';
export const ICON_HELP = 'icon-help';
export const ICON_HIDE = 'icon-hide';
export const ICON_HISTORY = 'icon-history';
export const ICON_HLOGO_CENTER = 'icon-hlogo-center';
export const ICON_HLOGO_LEFT = 'icon-hlogo-left';
export const ICON_HLOGO_RIGHT = 'icon-hlogo-right';
export const ICON_HOME = 'icon-home';
export const ICON_HOME_LINE = 'icon-home-line';
export const ICON_HOSPITAL = 'icon-hospital';
export const ICON_IMAGE = 'icon-image';
export const ICON_IMAGE_LINE = 'icon-image-line';
export const ICON_IMAGE_LINE_V2 = 'icon-image-line-v2';
export const ICON_IMPORT = 'icon-import';
export const ICON_IMPORTED = 'icon-imported';
export const ICON_INDENT = 'icon-indent';
export const ICON_INFO = 'icon-info';
export const ICON_INSERTORDEREDLIST = 'icon-insertorderedlist';
export const ICON_INSERTUNORDEREDLIST = 'icon-insertunorderedlist';
export const ICON_INTAKE_FORMS = 'icon-intake-forms';
export const ICON_ITALIC = 'icon-italic';
export const ICON_JURISDICTIONS = 'icon-jurisdictions';
export const ICON_LAUNCH = 'icon-launch';
export const ICON_LINK = 'icon-link';
export const ICON_LINK_DATA = 'icon-link-data';
export const ICON_LINK_THIN = 'icon-link-thin';
export const ICON_LINK_V2 = 'icon-link-v2';
export const ICON_LOCK = 'icon-lock';
export const ICON_LOCK_LINE = 'icon-lock-line';
export const ICON_LOGIN = 'icon-login';
export const ICON_LOGOUT = 'icon-logout';
export const ICON_LOGS = 'icon-logs';
export const ICON_LONG_ARROW_RIGHT = 'icon-long-arrow-right';
export const ICON_MAIL = 'icon-mail';
export const ICON_MAIL_LINE = 'icon-mail-line';
export const ICON_MENU = 'icon-menu';
export const ICON_MERGE_CELLS = 'icon-merge-cells';
export const ICON_MESSAGES = 'icon-messages';
export const ICON_MIC = 'icon-mic';
export const ICON_MINUS = 'icon-minus';
export const ICON_MOVE = 'icon-move';
export const ICON_MOVE_GROUP = 'icon-move-group';
export const ICON_MOVE_GROUP_V2 = 'icon-move-group-v2';
export const ICON_NEW_TEMPLATE = 'icon-new-template';
export const ICON_NOTE = 'icon-note';
export const ICON_NOTIFICATION = 'icon-notification';
export const ICON_OPEN_OUTSIDE = 'icon-open-outside';
export const ICON_OPEN_PANEL = 'icon-open-panel';
export const ICON_ORGANIZATION = 'icon-organization';
export const ICON_OUTDENT = 'icon-outdent';
export const ICON_PATHOLOGY = 'icon-pathology';
export const ICON_PAYMENT = 'icon-payment';
export const ICON_PDF = 'icon-pdf';
export const ICON_PENCIL_MAGIC = 'icon-pencil-magic';
export const ICON_PHONE = 'icon-phone';
export const ICON_PHYSICIAN = 'icon-physician';
export const ICON_PHYSICIAN_LINE = 'icon-physician-line';
export const ICON_PLAY = 'icon-play';
export const ICON_PLUS = 'icon-plus';
export const ICON_PLUS_CHAT = 'icon-plus-chat';
export const ICON_PLUS_CIRCLE = 'icon-plus-circle';
export const ICON_PREMIUM = 'icon-premium';
export const ICON_PRINT = 'icon-print';
export const ICON_QRCODE = 'icon-qrcode';
export const ICON_QUESTION_LINE = 'icon-question-line';
export const ICON_RELOAD = 'icon-reload';
export const ICON_REMOVE_FROM_GROUP = 'icon-remove-from-group';
export const ICON_REORDER = 'icon-reorder';
export const ICON_REPORT = 'icon-report';
export const ICON_REPORT_DOWNLOAD = 'icon-report-download';
export const ICON_REPORT_EDITING = 'icon-report-editing';
export const ICON_REPORT_FINISHED = 'icon-report-finished';
export const ICON_REPORT_GHOST = 'icon-report-ghost';
export const ICON_REPORT_IN_REVIEW = 'icon-report-in-review';
export const ICON_REPORT_NEEDS_REVIEW = 'icon-report-needs-review';
export const ICON_REPORT_NEW = 'icon-report-new';
export const ICON_REPORT_VIEW = 'icon-report-view';
export const ICON_RETURN = 'icon-return';
export const ICON_ROUTE = 'icon-route';
export const ICON_ROUTE_V2 = 'icon-route-v2';
export const ICON_SAD = 'icon-sad';
export const ICON_SAVE_TEMPLATE = 'icon-save-template';
export const ICON_SEARCH = 'icon-search';
export const ICON_SEARCH_RIGHT = 'icon-search-right';
export const ICON_SECURELY = 'icon-securely';
export const ICON_SELECT = 'icon-select';
export const ICON_SEND = 'icon-send';
export const ICON_SEND_V2 = 'icon-send-v2';
export const ICON_SETTINGS = 'icon-settings';
export const ICON_SETTINGS_LINE = 'icon-settings-line';
export const ICON_SHARE_FILLED = 'icon-share-filled';
export const ICON_SHARE_LINE = 'icon-share-line';
export const ICON_SHARE_LINE_V2 = 'icon-share-line-v2';
export const ICON_SHARE_V2 = 'icon-share-v2';
export const ICON_SHRINK = 'icon-shrink';
export const ICON_SIDEBAR = 'icon-sidebar';
export const ICON_SIGN_DOC = 'icon-sign-doc';
export const ICON_SIGN_OUT = 'icon-sign-out';
export const ICON_SORT = 'icon-sort';
export const ICON_SPLIT_CELLS = 'icon-split-cells';
export const ICON_SPLIT_DOC = 'icon-split-doc';
export const ICON_STAR = 'icon-star';
export const ICON_STAR_LINE = 'icon-star-line';
export const ICON_STARS_CHAT = 'icon-stars-chat';
export const ICON_STARS_CIRCLE = 'icon-stars-circle';
export const ICON_START_LINE_ULTRA_LIGHT = 'icon-start-line-ultra-light';
export const ICON_STATION = 'icon-station';
export const ICON_STRIKETHROUGH = 'icon-strikethrough';
export const ICON_STUDY_NOTES = 'icon-study-notes';
export const ICON_SVS = 'icon-svs';
export const ICON_TABLE = 'icon-table';
export const ICON_TAG_LINE = 'icon-tag-line';
export const ICON_TEMPLATE = 'icon-template';
export const ICON_TEMPLATES = 'icon-templates';
export const ICON_TEXTAREA = 'icon-textarea';
export const ICON_TEXTINPUT = 'icon-textinput';
export const ICON_THUMBS_DOWN = 'icon-thumbs-down';
export const ICON_THUMBS_UP = 'icon-thumbs-up';
export const ICON_TITLE = 'icon-title';
export const ICON_TXT = 'icon-txt';
export const ICON_UNARCHIVE = 'icon-unarchive';
export const ICON_UNAVAILABLE = 'icon-unavailable';
export const ICON_UNDERLINE = 'icon-underline';
export const ICON_UNDO_UNAVAILABLE = 'icon-undo-unavailable';
export const ICON_UNLOCK = 'icon-unlock';
export const ICON_UNLOCK_LINE = 'icon-unlock-line';
export const ICON_UNSIGN_DOC = 'icon-unsign-doc';
export const ICON_UPLOAD = 'icon-upload';
export const ICON_USER = 'icon-user';
export const ICON_USER_LINE = 'icon-user-line';
export const ICON_USERS = 'icon-users';
export const ICON_USERS_LINE = 'icon-users-line';
export const ICON_VIDEO = 'icon-video';
export const ICON_VIEW = 'icon-view';
export const ICON_WARNING = 'icon-warning';
export const ICON_X = 'icon-x';
export const ICON_X_CIRCLE = 'icon-x-circle';
export const ICON_X_CIRCLE_UNDO = 'icon-x-circle-undo';
export const ICON_XML = 'icon-xml';
export const ICON_ZIP = 'icon-zip';
export const ICON_ZIP_FILE = 'icon-zip-file';
export const ICON_ZOOM_IN = 'icon-zoom-in';
export const ICON_ZOOM_OUT = 'icon-zoom-out';
export const ICON_GHOST = 'icon-ghost';

export default {
    [ICON_ADD_BLANK]: '\uea00',
    [ICON_ADD_ROW_ABOVE]: '\uea01',
    [ICON_ADD_ROW_BELOW]: '\uea02',
    [ICON_ADD_ROW_LEFT]: '\uea03',
    [ICON_ADD_ROW_RIGHT]: '\uea04',
    [ICON_AI]: '\uea05',
    [ICON_ANALYTICS]: '\uea06',
    [ICON_ARCHIVE]: '\uea07',
    [ICON_ARROW_DOWN]: '\uea08',
    [ICON_ARROW_DOWN_LINE]: '\uea09',
    [ICON_ARROW_DOWN_LINE_SM]: '\uea0a',
    [ICON_ARROW_LEFT]: '\uea0b',
    [ICON_ARROW_LEFT_LINE]: '\uea0c',
    [ICON_ARROW_LEFT_LINE_SM]: '\uea0d',
    [ICON_ARROW_RIGHT]: '\uea0e',
    [ICON_ARROW_RIGHT_LINE]: '\uea0f',
    [ICON_ARROW_RIGHT_LINE_SM]: '\uea10',
    [ICON_ARROW_UP]: '\uea11',
    [ICON_ARROW_UP_LINE]: '\uea12',
    [ICON_ARROW_UP_LINE_SM]: '\uea13',
    [ICON_ATTACHMENT]: '\uea14',
    [ICON_AUDIT]: '\uea15',
    [ICON_BOLD]: '\uea16',
    [ICON_CALENDAR]: '\uea17',
    [ICON_CCDA]: '\uea18',
    [ICON_CHANGE_PATIENT]: '\uea19',
    [ICON_CHANGE_PATIENT_V2]: '\uea1a',
    [ICON_CHECK]: '\uea1b',
    [ICON_CHECK_FILES]: '\uea1c',
    [ICON_CHECKED_REPORT]: '\uea1d',
    [ICON_CLINICAL_SHEET]: '\uea1e',
    [ICON_CLOCK]: '\uea1f',
    [ICON_COLLABORATION]: '\uea20',
    [ICON_COPY]: '\uea21',
    [ICON_COPY_LINK]: '\uea22',
    [ICON_CREDIT_CARD]: '\uea23',
    [ICON_CSV]: '\uea24',
    [ICON_DASHBOARD]: '\uea25',
    [ICON_DELETE]: '\uea26',
    [ICON_DELETE_COLUMN]: '\uea27',
    [ICON_DELETE_ROW]: '\uea28',
    [ICON_DICOM]: '\uea29',
    [ICON_DICOM_NO_TEXT]: '\uea2a',
    [ICON_DIRECTORIES]: '\uea2b',
    [ICON_DIVISIONS]: '\uea2c',
    [ICON_DOTDOTDOT]: '\uea2d',
    [ICON_DOWNLOAD]: '\uea2e',
    [ICON_DOWNLOAD_CD]: '\uea2f',
    [ICON_DRAGGABLE]: '\uea30',
    [ICON_DRAGGABLE_CORNER]: '\uea31',
    [ICON_DRAGGABLE_VERTICAL]: '\uea32',
    [ICON_DROP_DOWN_SM]: '\uea33',
    [ICON_DROP_UP_SM]: '\uea34',
    [ICON_DROPDOWN]: '\uea35',
    [ICON_EDIT]: '\uea36',
    [ICON_EDIT_BOX]: '\uea37',
    [ICON_EDIT_LINE]: '\uea38',
    [ICON_ERASE]: '\uea39',
    [ICON_ERROR_HEX]: '\uea3a',
    [ICON_EXPAND]: '\uea3b',
    [ICON_EXPAND_V2]: '\uea3c',
    [ICON_EXTERNAL_LINK]: '\uea3d',
    [ICON_EXTERNAL_LINK_LINE]: '\uea3e',
    [ICON_EXTERNAL_REPORT]: '\uea3f',
    [ICON_EXTERNAL_USER]: '\uea40',
    [ICON_FAILURE]: '\uea41',
    [ICON_FAX]: '\uea42',
    [ICON_FEEDBACK]: '\uea43',
    [ICON_FILES]: '\uea44',
    [ICON_FILTER]: '\uea45',
    [ICON_FOLDER_BREAKING]: '\uea46',
    [ICON_FONTSIZEDOWN]: '\uea47',
    [ICON_FONTSIZEUP]: '\uea48',
    [ICON_HAPPY]: '\uea49',
    [ICON_HELP]: '\uea4a',
    [ICON_HIDE]: '\uea4b',
    [ICON_HISTORY]: '\uea4c',
    [ICON_HLOGO_CENTER]: '\uea4d',
    [ICON_HLOGO_LEFT]: '\uea4e',
    [ICON_HLOGO_RIGHT]: '\uea4f',
    [ICON_HOME]: '\uea50',
    [ICON_HOME_LINE]: '\uea51',
    [ICON_HOSPITAL]: '\uea52',
    [ICON_IMAGE]: '\uea53',
    [ICON_IMAGE_LINE]: '\uea54',
    [ICON_IMAGE_LINE_V2]: '\uea55',
    [ICON_IMPORT]: '\uea56',
    [ICON_IMPORTED]: '\uea57',
    [ICON_INDENT]: '\uea58',
    [ICON_INFO]: '\uea59',
    [ICON_INSERTORDEREDLIST]: '\uea5a',
    [ICON_INSERTUNORDEREDLIST]: '\uea5b',
    [ICON_INTAKE_FORMS]: '\uea5c',
    [ICON_ITALIC]: '\uea5d',
    [ICON_JURISDICTIONS]: '\uea5e',
    [ICON_LAUNCH]: '\uea5f',
    [ICON_LINK]: '\uea60',
    [ICON_LINK_DATA]: '\uea61',
    [ICON_LINK_THIN]: '\uea62',
    [ICON_LINK_V2]: '\uea63',
    [ICON_LOCK]: '\uea64',
    [ICON_LOCK_LINE]: '\uea65',
    [ICON_LOGIN]: '\uea66',
    [ICON_LOGOUT]: '\uea67',
    [ICON_LOGS]: '\uea68',
    [ICON_LONG_ARROW_RIGHT]: '\uea69',
    [ICON_MAIL]: '\uea6a',
    [ICON_MAIL_LINE]: '\uea6b',
    [ICON_MENU]: '\uea6c',
    [ICON_MERGE_CELLS]: '\uea6d',
    [ICON_MESSAGES]: '\uea6e',
    [ICON_MIC]: '\uea6f',
    [ICON_MINUS]: '\uea70',
    [ICON_MOVE]: '\uea71',
    [ICON_MOVE_GROUP]: '\uea72',
    [ICON_MOVE_GROUP_V2]: '\uea73',
    [ICON_NEW_TEMPLATE]: '\uea74',
    [ICON_NOTE]: '\uea75',
    [ICON_NOTIFICATION]: '\uea76',
    [ICON_OPEN_OUTSIDE]: '\uea77',
    [ICON_OPEN_PANEL]: '\uea78',
    [ICON_ORGANIZATION]: '\uea79',
    [ICON_OUTDENT]: '\uea7a',
    [ICON_PATHOLOGY]: '\uea7b',
    [ICON_PAYMENT]: '\uea7c',
    [ICON_PDF]: '\uea7d',
    [ICON_PENCIL_MAGIC]: '\uea7e',
    [ICON_PHONE]: '\uea7f',
    [ICON_PHYSICIAN]: '\uea80',
    [ICON_PHYSICIAN_LINE]: '\uea81',
    [ICON_PLAY]: '\uea82',
    [ICON_PLUS]: '\uea83',
    [ICON_PLUS_CHAT]: '\uea84',
    [ICON_PLUS_CIRCLE]: '\uea85',
    [ICON_PREMIUM]: '\uea86',
    [ICON_PRINT]: '\uea87',
    [ICON_QRCODE]: '\uea88',
    [ICON_QUESTION_LINE]: '\uea89',
    [ICON_RELOAD]: '\uea8a',
    [ICON_REMOVE_FROM_GROUP]: '\uea8b',
    [ICON_REORDER]: '\uea8c',
    [ICON_REPORT]: '\uea8d',
    [ICON_REPORT_DOWNLOAD]: '\uea8e',
    [ICON_REPORT_EDITING]: '\uea8f',
    [ICON_REPORT_FINISHED]: '\uea90',
    [ICON_REPORT_GHOST]: '\uea91',
    [ICON_REPORT_IN_REVIEW]: '\uea92',
    [ICON_REPORT_NEEDS_REVIEW]: '\uea93',
    [ICON_REPORT_NEW]: '\uea94',
    [ICON_REPORT_VIEW]: '\uea95',
    [ICON_RETURN]: '\uea96',
    [ICON_ROUTE]: '\uea97',
    [ICON_ROUTE_V2]: '\uea98',
    [ICON_SAD]: '\uea99',
    [ICON_SAVE_TEMPLATE]: '\uea9a',
    [ICON_SEARCH]: '\uea9b',
    [ICON_SEARCH_RIGHT]: '\uea9c',
    [ICON_SECURELY]: '\uea9d',
    [ICON_SELECT]: '\uea9e',
    [ICON_SEND]: '\uea9f',
    [ICON_SEND_V2]: '\ueaa0',
    [ICON_SETTINGS]: '\ueaa1',
    [ICON_SETTINGS_LINE]: '\ueaa2',
    [ICON_SHARE_FILLED]: '\ueaa3',
    [ICON_SHARE_LINE]: '\ueaa4',
    [ICON_SHARE_LINE_V2]: '\ueaa5',
    [ICON_SHARE_V2]: '\ueaa6',
    [ICON_SHRINK]: '\ueaa7',
    [ICON_SIDEBAR]: '\ueaa8',
    [ICON_SIGN_DOC]: '\ueaa9',
    [ICON_SIGN_OUT]: '\ueaaa',
    [ICON_SORT]: '\ueaab',
    [ICON_SPLIT_CELLS]: '\ueaac',
    [ICON_SPLIT_DOC]: '\ueaad',
    [ICON_STAR]: '\ueaae',
    [ICON_STAR_LINE]: '\ueaaf',
    [ICON_STARS_CHAT]: '\ueab0',
    [ICON_STARS_CIRCLE]: '\ueab1',
    [ICON_START_LINE_ULTRA_LIGHT]: '\ueab2',
    [ICON_STATION]: '\ueab3',
    [ICON_STRIKETHROUGH]: '\ueab4',
    [ICON_STUDY_NOTES]: '\ueab5',
    [ICON_SVS]: '\ueab6',
    [ICON_TABLE]: '\ueab7',
    [ICON_TAG_LINE]: '\ueab8',
    [ICON_TEMPLATE]: '\ueab9',
    [ICON_TEMPLATES]: '\ueaba',
    [ICON_TEXTAREA]: '\ueabb',
    [ICON_TEXTINPUT]: '\ueabc',
    [ICON_THUMBS_DOWN]: '\ueabd',
    [ICON_THUMBS_UP]: '\ueabe',
    [ICON_TITLE]: '\ueabf',
    [ICON_TXT]: '\ueac0',
    [ICON_UNARCHIVE]: '\ueac1',
    [ICON_UNAVAILABLE]: '\ueac2',
    [ICON_UNDERLINE]: '\ueac3',
    [ICON_UNDO_UNAVAILABLE]: '\ueac4',
    [ICON_UNLOCK]: '\ueac5',
    [ICON_UNLOCK_LINE]: '\ueac6',
    [ICON_UNSIGN_DOC]: '\ueac7',
    [ICON_UPLOAD]: '\ueac8',
    [ICON_USER]: '\ueac9',
    [ICON_USER_LINE]: '\ueaca',
    [ICON_USERS]: '\ueacb',
    [ICON_USERS_LINE]: '\ueacc',
    [ICON_VIDEO]: '\ueacd',
    [ICON_VIEW]: '\ueace',
    [ICON_WARNING]: '\ueacf',
    [ICON_X]: '\uead0',
    [ICON_X_CIRCLE]: '\uead1',
    [ICON_X_CIRCLE_UNDO]: '\uead2',
    [ICON_XML]: '\uead3',
    [ICON_ZIP]: '\uead4',
    [ICON_ZIP_FILE]: '\uead5',
    [ICON_ZOOM_IN]: '\uead6',
    [ICON_ZOOM_OUT]: '\uead7',
    [ICON_GHOST]: '\uead8',
}
